<template>
  <div class="row pt-2">
    <div class="col-12 col-md-6 px-0 pr-md-3">
      <label for="description">Data Mínima</label>
      <el-date-picker
        v-model="formData.min_date"
        :picker-options="{ disabledDate: disabledMinDate }"
        @input="emitInput"
        prefix-icon="fa fa-calendar"
        format="d 'de' MMMM 'de' yyyy"
      />
    </div>
    <div class="col-12 col-md-6 px-0">
      <label for="description">Data Máxima</label>
      <el-date-picker
        v-model="formData.max_date"
        :picker-options="{ disabledDate: disabledMaxDate }"
        @input="emitInput"
        prefix-icon="fa fa-calendar"
        format="d 'de' MMMM 'de' yyyy"
      />
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";

export default {
  name: "DateAvaliationItemStrategy",
  components: {
    [DatePicker.name]: DatePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        min_date: null,
        max_date: null,
      }),
    },
  },
  methods: {
    emitInput() {
      this.$emit("input", this.formData);
    },
    validateMaxDate() {
      if (this.formData.max_date.valueOf() < this.formData.min_date.valueOf()) {
        return "O valor máximo deve ser maior ou igual ao valor mínimo";
      }
      return;
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    disabledMinDate() {
      return (time) => {
        if (this.formData.max_date) {
          return time.getTime() > this.formData.max_date.valueOf();
        }
        return false;
      };
    },
    disabledMaxDate() {
      return (time) => {
        if (this.formData.min_date) {
          return time.getTime() < this.formData.min_date.valueOf();
        }
        return false;
      };
    },
  },
}
</script>
